import React from 'react';
import {
    RunnerDetails,
    RunnerDetailsWrapper,
    RunnerNameAndPlace,
} from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/GreyhoundAndTrainerDetails.style';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';

interface GreyhoundAndTrainerDetailsType {
    selectionId: SelectionId;
    isDetailsAvailable: boolean;
    className?: string;
    textTruncate?: boolean;
}

export const GreyhoundAndTrainerDetails = observer(
    'GreyhoundAndTrainerDetails',
    (props: GreyhoundAndTrainerDetailsType): JSX.Element | null => {
        const { className, isDetailsAvailable, selectionId, textTruncate = true } = props;

        const selectionModel = selectionId.getModel();
        if (selectionModel === null) {
            return null;
        }

        if (selectionModel.name === '') {
            return null;
        }

        const runner = (selectionModel.metaDataJockey ?? '').trim();
        const trainer = (selectionModel.metaDataTrainer ?? '').trim();
        const greyhoundName = selectionModel.name;

        return (
            <div className={className}>
                <RunnerNameAndPlace
                    data-test='runner-name'
                    title={greyhoundName}
                    textTruncate={textTruncate}
                >
                    {greyhoundName}
                </RunnerNameAndPlace>

                {isDetailsAvailable && (
                    <RunnerDetailsWrapper
                        data-test='runner-description'
                        textTruncate={textTruncate}
                    >
                        {runner !== '' && <RunnerDetails title={runner}>{runner}</RunnerDetails>}
                        {trainer !== '' && <RunnerDetails title={trainer}>{trainer}</RunnerDetails>}
                    </RunnerDetailsWrapper>
                )}
            </div>
        );
    }
);
